import { FC, useState } from 'react'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'

import { refetchFunc } from 'modules/domain/common/hooks'
import { DealPeriod, DealPeriodsTypes } from 'modules/domain/deal/types'
import { Progress, Spinner, Text } from '@agro-club/agroclub-shared'
import useFormatDate from 'hooks/useFormatDate'
import { Card } from 'views/components/Card/Card'
import { SpinnerWrapper } from 'views/styled/common'
import { DealPeriodForm } from './DealPeriodForm'
import { InputWrapper } from '../../../styled'
import { usePermissions } from 'views/components/PermissionCheck/usePermissions'
import { DASH } from 'modules/constants'

export const DealPeriodStep: FC<{
  dealPeriod?: DealPeriod
  dealId: string
  fetchProgress: Progress
  dealPeriodRefetch: refetchFunc
  type: DealPeriodsTypes
}> = ({ dealPeriod, dealPeriodRefetch, fetchProgress, type, dealId }) => {
  const { t } = useTranslation('deal')
  const [isEdit, setIsEdit] = useState(false)
  const formatDate = useFormatDate()
  const hasPermission = usePermissions(['deals.add_dealperiod'])

  if (fetchProgress != Progress.SUCCESS) {
    return (
      <SpinnerWrapper>
        <Spinner />
      </SpinnerWrapper>
    )
  }

  if ((dealPeriod && !isEdit) || !hasPermission) {
    // display: 'inline-flex' - to force line height 20px
    return (
      <>
        <InputWrapper>
          <div style={{ display: 'inline-flex' }}>
            <Text as="span" typography="bodyMedium">
              {`${t('contractSign.fillDateFrom')}:`}
            </Text>
            &nbsp;
            <Text as="span" typography="accentMedium">
              {dealPeriod?.start_date ? formatDate(dealPeriod.start_date) : DASH}
            </Text>
          </div>
          <div style={{ display: 'inline-flex' }}>
            <Text as="span" typography="bodyMedium">
              {`${t('contractSign.fillDateTo')}:`}
            </Text>
            &nbsp;
            <Text as="span" typography="accentMedium">
              {dealPeriod?.end_date ? formatDate(dealPeriod.end_date) : DASH}
            </Text>
          </div>
        </InputWrapper>
        {dealPeriod?.is_editable && <Card.EditButton id="editDealPeriod" onClick={() => setIsEdit(true)} />}
      </>
    )
  }
  const onSuccess = async () => {
    setIsEdit(false)
    await dealPeriodRefetch()
  }
  return <DealPeriodForm dealPeriod={dealPeriod} dealId={dealId} onSuccess={onSuccess} type={type} />
}
